export const SERVER_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : "https://alcsvc-be.herokuapp.com";

export const AUTH_JWT = "jwt";
